var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5268 4C20.0377 4 17.8584 5.15652 16.5 7.11141C15.1416 5.15652 12.9623 4 10.4732 4C8.49188 4.00241 6.59234 4.85393 5.19132 6.36773C3.7903 7.88153 3.00223 9.93399 3 12.0748C3 21.1916 15.5104 28.5709 16.0432 28.8757C16.1836 28.9573 16.3406 29 16.5 29C16.6594 29 16.8164 28.9573 16.9568 28.8757C17.4896 28.5709 30 21.1916 30 12.0748C29.9978 9.93399 29.2097 7.88153 27.8087 6.36773C26.4077 4.85393 24.5081 4.00241 22.5268 4Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/Heart-filled.5c603ebc0ef780a8f85d2b08691c9ebb.svg";
export { ForwardRef as ReactComponent };